export default function WagerTerms() {
  return (
    <div className="page">
      <div className="card">
        <h1 className="text-2xl font-bold">Wager Terms & Conditions</h1>
        <div className="prose prose-invert mt-4 max-w-none">
          <ol>
            <li><strong>Peer-to-Peer Only.</strong> Wagers are private agreements between participating members. GAStreaming acts only as a venue to list, find, and coordinate matches.</li>
            <li><strong>Rules & Modes.</strong> Creator must state game, mode, platform, amount, and any house rules. Opponent accepts those terms at the time of joining.</li>
            <li><strong>Match Results.</strong> After each match, both players must report the result truthfully. If reports disagree, the match is marked “disputed” and may be reviewed.</li>
            <li><strong>Disputes.</strong> Provide clear evidence (screenshots or short clips). Admin decisions may resolve disputes; repeated abuse can lead to account action.</li>
            <li><strong>Cancellation.</strong> A creator may cancel an “open” wager anytime before an opponent accepts. Once accepted, the match should be played as scheduled.</li>
            <li><strong>No Cheating / Exploits.</strong> Using cheats, hacks, or exploits is prohibited and may result in permanent removal.</li>
            <li><strong>Compliance.</strong> Members are responsible for following local laws/regulations regarding skill-based contests.</li>
            <li><strong>Payments.</strong> GAStreaming does not take a fee from P2P wagers. Escrow/payout automation may be added later. Until then, treat wagers as good-faith matches.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
